import { getStorage } from '../../../home24/helpers/storage-factory';
import BaseTrackingView from '../../core/baseTrackingView';

export default BaseTrackingView.extend({

    events: {
        'click [data-role="event-change-address"]': 'onAddressChange',
        'submit form.myaccount-address': 'onAddressChange'
    },

    cookieCallbacks: {
        GtmOnAddressChanged: 'afterAddressChanged'
    },

    onAddressChange: function () {
        getStorage().set('GtmOnAddressChanged', 1);
    },

    /**
     * Callback executed after user changes address on checkout address page
     */
    afterAddressChanged: function () {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'checkoutOption',
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 2,
                            option: 'change_address'
                        }
                    }
                }
            });
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/checkout/Address.js
 **/